module.exports = {
  "id": "6a9444ac-2764-4d7d-aa44-1594b5f1ba95",
  "gtmIds": [
    "GTM-NM5F945"
  ],
  "hasInAppVersion": true,
  "group": "gausta",
  "language": "nb-NO",
  "languages": [
    "nb-NO",
    "en-US"
  ],
  "website": "https://www.gausta.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}